import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CiudadesServiceService } from './shared/ciudades-service.service';
import { ToastrService } from 'ngx-toastr';
import 'datatables.net';
import 'datatables.net-bs4';
import { Ciudad } from './shared/ciudad.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-ciudades',
  templateUrl: './ciudades.component.html',
  styleUrls: ['./ciudades.component.css']
})
export class CiudadesComponent implements OnInit {

  datatable: any;

  ListCiudades: Ciudad[] = [];

  constructor(private ciudadService: CiudadesServiceService,
    private toastr: ToastrService,
    private chRef: ChangeDetectorRef) {

  }

  getCities() {

    this.ciudadService.getCitys().then(
      (r: Ciudad[]) => {
        if ($.fn.dataTable.isDataTable('#datatable')) {
          this.datatable.destroy();
        }

        this.ListCiudades = r as Ciudad[];

        this.chRef.detectChanges();

        const table: any = $('table');
        this.datatable = table.DataTable({
          responsive: true
        });
      }
    );
  }

  ngOnInit() {
    this.getCities();
    //this.refreshList()
  }

  refreshList() {
    this.ciudadService.getCitys();
  }

  updateCities() {
    this.ciudadService.updateCities().then(r => { this.toastr.success("Ciudad Actualizada") }, err => { this.toastr.error(err.message) });
  }

}
